import { ReactComponent as GPTWLogoIcon } from "assets/svgs/gptw-logo-icon.svg";
import { ReactComponent as GPMHLogoIcon } from "assets/svgs/gpmh-logo-icon.svg";
import { ReactComponent as ClasseLogoIcon } from "assets/svgs/classe-sa-logo.svg";
import { ReactComponent as IIAIcon } from "assets/svgs/iia-logo.svg";
import { ReactComponent as WOBIcon } from "assets/svgs/wob-logo.svg";
import { ReactComponent as UnGlobalCompactIcon } from "assets/svgs/un-global-compact-logo.svg";
import { ReactComponent as PactoBrasilIcon } from "assets/svgs/pacto-brasil-logo.svg";
import { ReactComponent as MovimentoTransparenciaIcon } from "assets/svgs/movimento-transparencia-logo.svg";
import { ReactComponent as MovimentoElasIcon } from "assets/svgs/movimento-elas-logo.svg";

import * as S from "./AchievementsStamp.style";

const achievementList = [
  {
    id: 1,
    icon: GPTWLogoIcon,
    title: "Great Place to Work",
    description:
      "Certifica empresas que prezam por excelência em suas culturas e ambientes de trabalho",
  },
  {
    id: 9,
    icon: GPMHLogoIcon,
    title: "Mental Health",
    description:
      "Certifica empresas que se destacam na promoção da saúde mental e do bem-estar dos colaboradores.",
  },
  {
    id: 2,
    icon: ClasseLogoIcon,
    title: "ClienteSA",
    description:
      "Reconhece empresas com as melhores práticas em experiência do cliente (CX) do mercado brasileiro.",
  },
  {
    id: 3,
    icon: IIAIcon,
    title: "IIA",
    description:
      "Conscientiza sobre a importância estratégica da Auditoria Interna.",
  },
  {
    id: 4,
    icon: WOBIcon,
    title: "Woman on Board",
    description:
      "Certifica empresas comprometidas com a diversidade e com a igualdade de gênero em Conselhos Executivos e cargos de alta gestão.",
  },
  {
    id: 6,
    icon: PactoBrasilIcon,
    title: "Pacto Brasil",
    description:
      "Iniciativa da CGU que estimula empresas a assumirem compromisso com a integridade empresarial.",
  },
  {
    id: 5,
    icon: UnGlobalCompactIcon,
    title: "UN Global Compact",
    description: "Signatária do pacto Global da ONU.",
  },
  {
    id: 7,
    icon: MovimentoTransparenciaIcon,
    title: "Transparência 100%",
    description:
      "Compromisso em garantir 100% de transparência sobre a estrutura de Compliance e Governança.",
  },
  {
    id: 8,
    icon: MovimentoElasIcon,
    title: "Elas Lideram 2030",
    description:
      "Compromisso em impulsionar a presença feminina em cargos de alta liderança.",
  },
];

const AchievementsStamp = () => {
  return (
    <S.AchievementsStampContainer>
      <S.AchievementsStampContent className="container">
        <S.AchievementsStampHeader>
          <S.AchievementsStampTitle>
            Selos e certificações
          </S.AchievementsStampTitle>

          <S.AchievementsStampDescription>
            Cuidar das pessoas é o que nos move. Como empresa cidadã, fazemos
            isso guiados por práticas ambientais, sociais e de governança. Esse
            compromisso tem sido reconhecido por meio de selos e certificações
            que refletem o nosso jeito de ser.
          </S.AchievementsStampDescription>
        </S.AchievementsStampHeader>

        <S.AchievementsStampList>
          {achievementList.map((achievementItem) => (
            <S.AchievementsStampItem key={achievementItem.id}>
              <S.AchievementsStampImage>
                <achievementItem.icon />
              </S.AchievementsStampImage>

              <S.AchievementsStampBlock>
                <S.AchievementsStampItemTitle>
                  {achievementItem.title}
                </S.AchievementsStampItemTitle>

                <S.AchievementsStampDescription>
                  {achievementItem.description}
                </S.AchievementsStampDescription>
              </S.AchievementsStampBlock>
            </S.AchievementsStampItem>
          ))}
        </S.AchievementsStampList>
      </S.AchievementsStampContent>
    </S.AchievementsStampContainer>
  );
};

export default AchievementsStamp;
